import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { SPACES } from 'common/constants/sizes';

export const SeriesIcon = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${({ $color }) => $color};
`;
export const SeriesName = styled.div``;
export const SeriesData = styled.div``;

export const MultiSeriesLegend = styled(Flex)`
  margin-bottom: ${SPACES['smaller']};
  align-items: center;
  width: 100%;
  opacity: ${({ $selected }) => !$selected && 0.6};
  font-weight: ${({ $selected }) => $selected && 'bold'};

  & ${SeriesIcon} {
    margin-right: ${SPACES['small']};
  }
  & ${SeriesName} {
    margin-right: ${SPACES['medium']};
  }
  & ${SeriesData} {
    margin-left: auto;
  }
`;
